var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-world-comments"},[_c('world-map',{attrs:{"comments":_vm.comments,"active-id":_vm.activeId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }